import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {Flex} from '@travel-frontend/ui-components';

export const Container = styled(Flex)`
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  background: linear-gradient(180deg, #2986f2 28.15%, #002873 100%);

  ${({theme}) =>
    theme.respondTo(
      'sm',
      css`
        flex-direction: row;
        height: 126px;
      `
    )};

  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        height: 160px;
      `
    )};
`;
